import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ProductTemplateDTO, ProductTemplateImageInputDTO } from '../../../base/models/models.swagger.generated';
import { ProductTemplateFormType } from './product-template-edit-form';

@Component({
  selector: 'app-product-template-edit-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    InputTextareaModule,
    MultiSelectModule,
    DropdownModule,
    ButtonModule,
    TranslateModule,
    CommonModule
  ],
  templateUrl: './product-template-edit-dialog.component.html',
  styleUrls: ['./product-template-edit-dialog.component.scss']
})
export class ProductTemplateEditDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() template: ProductTemplateDTO | null = null;
  @Input() form: FormGroup<ProductTemplateFormType>;
  @Input() categories: any[] = [];
  @Input() deliveryOptions: any[] = [];
  @Input() unitTypeOptions: any[] = [];
  @Input() unitCategoryOptions: any[] = [];
  @Input() templateImages: ProductTemplateImageInputDTO[] = [];
  @Input() existingImages: ProductTemplateImageInputDTO[] = [];
  @Input() removeImageIds: number[] = [];
  @Input() setPrimaryImageId: number | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<void>();
  @Output() imageSelected = new EventEmitter<Event>();
  @Output() imageRemoved = new EventEmitter<number>();
  @Output() existingImageRemoved = new EventEmitter<number>();
  @Output() primaryImageSet = new EventEmitter<number>();
  @Output() primaryExistingImageSet = new EventEmitter<number>();

  dialogVisible: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']) {
      this.dialogVisible = this.visible;
    }
  }

  onVisibleChange(value: boolean) {
    this.dialogVisible = value;
    this.visibleChange.emit(value);
  }

  onCancel() {
    this.onVisibleChange(false);
  }

  onSave() {
    this.save.emit();
  }

  onImageSelected(event: Event) {
    this.imageSelected.emit(event);
  }

  removeImage(index: number) {
    this.imageRemoved.emit(index);
  }

  removeExistingImage(index: number) {
    this.existingImageRemoved.emit(index);
  }

  setPrimaryImage(index: number) {
    this.primaryImageSet.emit(index);
  }

  setPrimaryExistingImage(index: number) {
    this.primaryExistingImageSet.emit(index);
  }
}
